import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.png';
import { authApi, configApi } from '../services';
import Header from '../components/Header';

function LoginPage({ onNavigate }) {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [contactInfo, setContactInfo] = useState({
    contact_email: '',
    contact_mobile_number: ''
  });
  const [loadingContactInfo, setLoadingContactInfo] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.username.trim() || !formData.password.trim()) {
      setError('Vui lòng nhập đầy đủ thông tin');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await authApi.login({
        username: formData.username,
        password: formData.password
      });
      
      console.log('Login response:', response);
      
      // Save token if available
      if (response.payload.token) {
        if(response.payload.user_info.role_id == 4){
          localStorage.setItem('token', response.payload.token);
          localStorage.setItem('user_info', JSON.stringify(response.payload.user_info));
          
          // Check if user must change password for first time
          if (response.payload.user_info.must_change_password === 1) {
            onNavigate('/change-password');
          } else {
            onNavigate('/');
          }
        }else{
          setError('Bạn không có quyền truy cập');
        }
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(error.response?.data?.message || 'Đăng nhập thất bại. Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  // Fetch contact info when forgot password modal is opened
  const handleForgotPasswordClick = async () => {
    setShowForgotPasswordModal(true);
    setLoadingContactInfo(true);
    
    try {
      const response = await configApi.getContactInfo();
      if (response.ok && response.payload) {
        setContactInfo(response.payload);
      }
    } catch (error) {
      console.error('Error fetching contact info:', error);
      // Fallback to default values if API fails
      setContactInfo({
        contact_email: 'admin@thetimehub.com',
        contact_mobile_number: 'Admin TheTimeHub'
      });
    } finally {
      setLoadingContactInfo(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 40 }}>
      <div style={{ background: '#fff', width: 320, minHeight: 600, borderRadius: 8, padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Header
          onCartClick={() => {
            onNavigate(-1);
          }}
          onMenuClick={() => {
            onNavigate("/");
          }}
        />
        
        <div style={{ width: '100%', marginBottom: 20, marginTop: 100 }}>
          <label style={{ fontWeight: 400, fontSize: 16 }}>Tài khoản</label>
          <input 
            type="text" 
            name="username"
            placeholder="Nhập tên đăng nhập" 
            style={{
              ...inputStyle,
              borderColor: error ? '#ff4444' : '#bfc3b7'
            }} 
            value={formData.username} 
            onChange={handleInputChange}
          />
        </div>
        
        <div style={{ width: '100%', marginBottom: 8 }}>
          <label style={{ fontWeight: 400, fontSize: 16 }}>Mật khẩu</label>
          <div style={{ position: 'relative' }}>
            <input 
              type={showPassword ? 'text' : 'password'} 
              name="password"
              placeholder="Nhập mật khẩu" 
              style={{
                ...inputStyle,
                borderColor: error ? '#ff4444' : '#bfc3b7'
              }} 
              value={formData.password} 
              onChange={handleInputChange}
            />
            <span onClick={() => setShowPassword(v => !v)} style={eyeIconStyle}>
              {showPassword ? '🙈' : '👁️'}
            </span>
          </div>
        </div>
        
        <div style={{ width: '100%', textAlign: 'right', marginBottom: 50 }}>
          <span style={{ fontSize: 13, color: '#222', cursor: 'pointer' }} onClick={handleForgotPasswordClick}>
            Quên mật khẩu?
          </span>
        </div>
        
        {error && (
          <div style={{ 
            color: '#ff4444', 
            fontSize: 14, 
            marginBottom: 16,
            textAlign: 'center',
            background: '#fee',
            border: '1px solid #fcc',
            borderRadius: 8,
            padding: '8px 12px'
          }}>
            {error}
          </div>
        )}
        
        <div style={{ width: '100%', textAlign: 'right', marginBottom: 24 }}>
          <button 
            style={{
              ...btnStyle,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Đang đăng nhập...' : 'Đăng nhập'}
          </button>
        </div>
        
        <div style={{ marginTop: 32, fontSize: 14, fontWeight: 300, width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          Chưa có tài khoản?{' '}
          <span style={{ color: '#2a6be4', cursor: 'pointer' }} onClick={() => onNavigate('register')}>
            Đăng ký
          </span>
        </div>
      </div>

      {/* Forgot Password Modal */}
      {showForgotPasswordModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 12,
            padding: 24,
            width: 300,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            textAlign: 'center'
          }}>
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 18, fontWeight: 600, color: '#5b6754', marginBottom: 8 }}>
                Quên mật khẩu?
              </div>
              <div style={{ fontSize: 14, color: '#666', lineHeight: '1.5' }}>
                Vui lòng ra quầy thu ngân hoặc liên hệ admin để được hỗ trợ đặt lại mật khẩu
              </div>
            </div>

            <div style={{ 
              background: '#f8f8f8', 
              borderRadius: 8, 
              padding: 16, 
              marginBottom: 20,
              textAlign: 'left'
            }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#5b6754', marginBottom: 8 }}>
                Thông tin liên hệ:
              </div>
              {loadingContactInfo ? (
                <div style={{ fontSize: 13, color: '#666', textAlign: 'center', padding: '8px 0' }}>
                  Đang tải thông tin...
                </div>
              ) : (
                <>
                  <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}>
                    📧 Email: <strong>{contactInfo.contact_email}</strong>
                  </div>
                  <div style={{ fontSize: 13, color: '#666' }}>
                    💬 Zalo: <strong>{contactInfo.contact_mobile_number}</strong>
                  </div>
                </>
              )}
            </div>

            <button
              onClick={() => setShowForgotPasswordModal(false)}
              style={{
                width: '100%',
                padding: '12px 16px',
                background: '#5b6754',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                fontSize: 14,
                cursor: 'pointer',
                fontFamily: 'NeueEinstellung'
              }}
            >
              Đã hiểu
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const inputStyle = {
  width: '100%',
  height: 44,
  border: '1px solid #bfc3b7',
  borderRadius: 22,
  padding: '0 44px 0 16px',
  fontSize: 16,
  marginTop: 4,
  outline: 'none',
  boxSizing: 'border-box',
};

const btnStyle = {
  width: 135,
  height: 48,
  background: '#5b6754',
  color: '#fff',
  border: 'none',
  borderRadius: 24,
  fontSize: 16,
  margin: '12px 0',
  cursor: 'pointer',
  fontFamily: 'NeueEinstellung',
  fontWeight: 300,
  float: 'right',
};

const eyeIconStyle = {
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: 20,
  cursor: 'pointer',
  userSelect: 'none',
};

export default LoginPage;
